import * as React from 'react';
import {Text, View} from 'react-native';
import {Field} from 'redux-form';
import {BaseField} from '../../../../shared/components/baseField';
import {Button} from '../../../../shared/components/button';
import {useStyles} from '../../../../shared/hooks/styles';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {SendCodeResponsePayload} from '../../../../shared/models/api';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {CountDownTimer, CountDownTimerRefProps} from '../../../login/components/countDownTimer';

interface Props {
  onRefresh: () => void;
  sendCodeResponse: SendCodeResponsePayload;
}

export default ({onRefresh, sendCodeResponse}: Props) => {
  const countDownTimerRef = React.useRef<CountDownTimerRefProps | null>(null);
  const [isResendButtonDisabled, setResendButtonDisabled] = React.useState(true);
  const isDesktop = useIsDesktop();
  const styles = useStyles(({theme, platformOnly, mediaOnly}) => {
    return {
      container: {
        ...mediaOnly(
          DeviceSize.desktop,
          {paddingTop: 0, paddingBottom: 0},
          {flex: 1, paddingTop: 40, paddingBottom: 80},
        ),
        flexDirection: 'column',
        alignItems: 'center',
        ...platformOnly('web', {}, {justifyContent: 'space-between'}),
      },
      lowerBlock: {
        flexDirection: 'column',
        alignItems: 'center',
      },
      message: {
        textAlign: 'center',
        ...mediaOnly(
          DeviceSize.desktop,
          {width: 352, maxWidth: 352, ...theme.fonts.h6Light},
          {maxWidth: 270, ...theme.fonts.body},
        ),
        ...platformOnly(
          'web',
          mediaOnly(DeviceSize.desktop, {marginTop: 30, marginBottom: 30}, {marginBottom: 60}),
          {},
        ),
      },
      button: {
        width: 240,
        marginTop: 16,
      },
    };
  });

  return (
    <View style={styles.container}>
      {isDesktop && (
        <Field component={BaseField} label='Эл. почта' type='text' style={{maxWidth: 300}} name='email' disabled />
      )}
      <Text style={styles.message}>
        {sendCodeResponse?.message || 'На вашу электронную почту отправлено письмо со ссылкой на подтверждение.'}
      </Text>
      <View style={styles.lowerBlock}>
        <CountDownTimer
          ref={countDownTimerRef}
          onTimerEnd={() => {
            setResendButtonDisabled(false);
          }}
          until={sendCodeResponse?.resendCountdown || 300}
        />
        <Button
          id='profile-email-confirmation-resend'
          style={styles.button}
          disabled={isResendButtonDisabled}
          type='primary'
          text='Отправить повторно'
          onPress={() => {
            try {
              onRefresh();
              countDownTimerRef.current?.resetTimer();
              setResendButtonDisabled(true);
            } catch (err) {}
          }}
        />
      </View>
    </View>
  );
};
